import React from 'react';

import { useTheme } from '@mui/material';

import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { useIsDesktop } from '@vk-hr-tek/ui/hooks';
import { NoContentIcon } from '@vk-hr-tek/ui/icons';

type IProps = {
  title: string;
  noImg?: boolean;
  noBorder?: boolean;
};

export const EmptyListPlug = ({ title, noImg, noBorder }: IProps) => {
  const theme = useTheme();
  const isDesktop = useIsDesktop();

  return (
    <Box
      bgcolor="bg.light.primary"
      border={
        noBorder
          ? ''
          : `${theme.tokens.border.s}px solid ${theme.tokens.colors.stroke.primary}`
      }
      overflow="hidden"
      radius="l"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="40"
      py="56"
      mx={isDesktop ? '0' : '16'}
    >
      {!noImg && <NoContentIcon />}
      <Box maxWidth={isDesktop ? '100%' : '214px'}>
        <Typography
          align="center"
          variant={isDesktop ? 'body2' : 'body3'}
          color="text.light.secondary"
        >
          {title}
        </Typography>
      </Box>
    </Box>
  );
};
